import { Creatable as ReactSelect } from 'react-select';

import PropTypes from 'prop-types';

export default class Select extends React.PureComponent {
  static propTypes = {
    autoFocus: PropTypes.bool,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    isClearable: PropTypes.bool,
    multi: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onBlur: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    onNewOptionClick: PropTypes.func,
    onNewOptionCreate: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    styles: PropTypes.object,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
  };

  static defaultProps = {
    autoFocus: false,
    className: '',
    disabled: false,
    multi: false,
    styles: {},
  };

  render() {
    const {
      autoFocus,
      className,
      disabled,
      isClearable,
      multi,
      name,
      onBlur,
      onChange,
      onNewOptionClick,
      onNewOptionCreate,
      options,
      styles,
      title,
      value,
    } = this.props;

    return (
      <ReactSelect
        autoFocus={autoFocus}
        className={className}
        classNamePrefix="Edocat-Select"
        formatCreateLabel={label =>
          `${window.Alfresco.messages.global['edocat.react-select.creatable.create-new']} "${label}"`
        }
        id={name}
        isClearable={isClearable}
        isDisabled={disabled}
        isMulti={multi}
        name={name}
        noOptionsMessage={() => window.Alfresco.messages.global['edocat.text.no-results']}
        onBlur={onBlur}
        onChange={onChange}
        onCreateOption={onNewOptionCreate || onNewOptionClick}
        options={options}
        placeholder={`${window.Alfresco.messages.global['button.select']}...`}
        searchPromptText={window.Alfresco.messages.global['edocat.forms.select.search-prompt-text']}
        styles={styles}
        title={title}
        value={value}
      />
    );
  }
}
